import { AuthConstants, ForgotPasswordConstants } from "@/redux/types";
import { authApi as api } from "@/api/auth.api";

export const authAction = {
	login,
	forgotPassword,
	verifyOtpCode,
	resetPassword,
	resendOtpCode,
};

function login(form_data) {
	return async (dispatch) => {
		try {
			const payload = await api._login(form_data);
			console.log("Login payload:", payload);
			if (payload && payload.accessToken && payload.user) {
				dispatch(success(payload));
				return { success: true, data: payload };
			} else {
				const error = payload?.message || "Invalid response from server";
				dispatch(failure(error));
				return { success: false, error };
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || error.message || "Login failed";
			dispatch(failure(errorMessage));
			return { success: false, error: errorMessage };
		}
	};

	function success(payload) {
		return { type: AuthConstants.LOGIN, payload };
	}
	function failure(error) {
		return { type: AuthConstants.FAILED, error };
	}
}

function forgotPassword(form_data) {
	return async (dispatch) => {
		try {
			const payload = await api._forgotPassword(form_data);
			if (payload && payload.message && payload.email) {
				dispatch(success(payload));
				return { success: true, data: payload };
			} else {
				const error = payload?.message || "Invalid response from server";
				dispatch(failure(error));
				return { success: false, error };
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				error.message ||
				"Request Forgot failed";
			dispatch(failure(errorMessage));
			return { success: false, error: errorMessage };
		}
	};

	function success(payload) {
		return { type: ForgotPasswordConstants.REQUEST, payload };
	}
	function failure(error) {
		return { type: ForgotPasswordConstants.FAILED, error };
	}
}

function verifyOtpCode(form_data) {
	return async (dispatch) => {
		try {
			const payload = await api._verifyOtpCode(form_data);
			if (payload && payload.otpVerified) {
				dispatch(success(payload));
				return { success: true, data: payload };
			} else {
				const error = payload?.message || "Invalid response from server";
				dispatch(failure(error));
				return { success: false, error };
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message || error.message || "Verify Otp failed";
			dispatch(failure(errorMessage));
			return { success: false, error: errorMessage };
		}
	};

	function success(payload) {
		return { type: ForgotPasswordConstants.VERIFY_OTP_REQUEST, payload };
	}
	function failure(error) {
		return { type: ForgotPasswordConstants.VERIFY_OTP_FAILED, error };
	}
}

function resetPassword(form_data) {
	return async (dispatch) => {
		try {
			const payload = await api._resetPassword(form_data);
			if (payload && payload.resetPassword) {
				dispatch(success(payload));
				return { success: true, data: payload };
			} else {
				const error = payload?.message || "Invalid response from server";
				dispatch(failure(error));
				return { success: false, error };
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				error.message ||
				"Reset Password failed";
			dispatch(failure(errorMessage));
			return { success: false, error: errorMessage };
		}
	};

	function success(payload) {
		return { type: ForgotPasswordConstants.VERIFY_OTP_SUCCESS, payload };
	}
	function failure(error) {
		return { type: ForgotPasswordConstants.VERIFY_OTP_FAILED, error };
	}
}

function resendOtpCode(form_data) {
	return async (dispatch) => {
		try {
			console.log("Resend OTP form data:", form_data);
			const payload = await api._resendOtpCode(form_data);
			if (payload && payload.resendOtpVerified) {
				dispatch(success(payload));
				return { success: true, data: payload };
			} else {
				const error = payload?.message || "Invalid response from server";
				dispatch(failure(error));
				return { success: false, error };
			}
		} catch (error) {
			const errorMessage =
				error.response?.data?.message ||
				error.message ||
				"Reset Password failed";
			dispatch(failure(errorMessage));
			return { success: false, error: errorMessage };
		}
	};

	function success(payload) {
		return { type: ForgotPasswordConstants.RESEND_OTP_REQUEST, payload };
	}
	function failure(error) {
		return { type: ForgotPasswordConstants.RESEND_OTP_FAILED, error };
	}
}
